// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-page-new {
    padding: 0;
}

/* Welcome Section */
.welcome-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    flex-wrap: wrap;
    gap: 1.5rem;
}

.welcome-section h1 {
    font-size: 2rem;
    margin: 0;
    color: #1a1a1a;
    font-weight: 700;
}

.welcome-subtitle {
    color: #666;
    margin: 0.5rem 0 0;
    font-size: 1.05rem;
}

.btn-primary {
    background: linear-gradient(135deg, #f7bd20, #f5a623);
    color: #1a1a1a;
    border: none;
    padding: 0.9rem 1.75rem;
    border-radius: 12px;
    font-weight: 700;
    font-size: 1rem;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s ease;
    box-shadow: 0 4px 15px rgba(247, 189, 32, 0.3);
}

.btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(247, 189, 32, 0.4);
}

.btn-secondary {
    background: #f5f7fa;
    color: #1a1a1a;
    border: 1px solid #ddd;
    padding: 0.9rem 1.75rem;
    border-radius: 12px;
    font-weight: 600;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-secondary:hover {
    background: #e8ecf0;
}

/* Clean Stats Cards */
.stats-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    grid-gap: 1.5rem;
    gap: 1.5rem;
    margin-bottom: 2rem;
}

.stat-card-new {
    background: #ffffff;
    padding: 1.5rem;
    border-radius: 12px;
    border: 1px solid #edf2f7;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-card-new:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08);
}

.stat-card-new.primary-card {
    border-top: 4px solid #f7bd20;
}

.stat-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
}

.stat-icon {
    font-size: 1.25rem;
}

.stat-label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #4a5568;
    text-transform: uppercase;
    letter-spacing: 0.025em;
}

.stat-value-large {
    font-size: 1.875rem;
    font-weight: 700;
    color: #1a202c;
    margin: 0.25rem 0;
}

.stat-footer {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #f7fafc;
}

.stat-badge {
    font-size: 0.75rem;
    font-weight: 700;
    padding: 0.25rem 0.75rem;
    border-radius: 9999px;
}

.stat-text {
    font-size: 0.875rem;
    color: #718096;
}

.score-bar {
    height: 6px;
    background: #edf2f7;
    border-radius: 3px;
    overflow: hidden;
    margin-top: 0.75rem;
}

.score-fill {
    height: 100%;
    background: #f7bd20;
    border-radius: 3px;
    transition: width 1s ease-in-out;
}

/* Dashboard Content Sections */
.content-section {
    background: #ffffff;
    padding: 2rem;
    border-radius: 12px;
    border: 1px solid #edf2f7;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.section-header-new {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
}

.section-header-new h2 {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1a202c;
    margin: 0;
}

.loan-count {
    background: #1a1a1a;
    color: #f7bd20;
    padding: 0.5rem 1.25rem;
    border-radius: 12px;
    font-size: 0.85rem;
    font-weight: 700;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* Loans Grid */
.loans-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    grid-gap: 1.5rem;
    gap: 1.5rem;
}

.loan-card-new {
    background: rgba(255, 255, 255, 0.6);
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 20px;
    padding: 1.75rem;
    transition: all 0.3s ease;
}

.loan-card-new:hover {
    border-color: rgba(247, 189, 32, 0.4);
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.loan-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1.25rem;
    gap: 1rem;
}

.loan-card-header h3 {
    font-size: 1.25rem;
    margin: 0 0 0.4rem;
    color: #1a1a1a;
    font-weight: 700;
}

.account-number {
    font-size: 0.85rem;
    color: #666;
    font-weight: 500;
}

.status-badge {
    padding: 0.4rem 0.9rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    white-space: nowrap;
}

.status-badge.active {
    background: rgba(34, 197, 94, 0.15);
    color: #16a34a;
}

.loan-amount-display {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1.25rem;
    background: linear-gradient(135deg, rgba(247, 189, 32, 0.1), rgba(247, 189, 32, 0.05));
    border-radius: 12px;
    margin-bottom: 1.25rem;
}

.amount-label {
    font-size: 0.85rem;
    color: #666;
    font-weight: 600;
}

.amount-value {
    font-size: 1.75rem;
    font-weight: 800;
    color: #1a1a1a;
}

.loan-info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1.25rem;
    gap: 1.25rem;
    margin-bottom: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid #f5f7fa;
}

.info-item {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.info-label {
    font-size: 0.85rem;
    color: #666;
    font-weight: 500;
}

.info-value {
    font-size: 1.1rem;
    font-weight: 700;
    color: #1a1a1a;
}

.loan-progress-section {
    margin-bottom: 1.5rem;
}

.progress-label {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.75rem;
    font-size: 0.9rem;
    font-weight: 600;
    color: #666;
}

.progress-percent {
    color: #f7bd20;
    font-weight: 700;
}

.progress-bar-new {
    height: 8px;
    background: #f5f7fa;
    border-radius: 10px;
    overflow: hidden;
}

.progress-bar-fill {
    height: 100%;
    background: linear-gradient(90deg, #f7bd20, #f5a623);
    border-radius: 10px;
    transition: width 1s ease;
}

.btn-pay-emi {
    width: 100%;
    padding: 0.9rem;
    background: linear-gradient(135deg, #1a1a1a, #333);
    color: #f7bd20;
    border: none;
    border-radius: 10px;
    font-weight: 700;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-pay-emi:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

/* Quick Actions Grid */
.quick-actions-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    grid-gap: 1.25rem;
    gap: 1.25rem;
}

.action-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
    padding: 2rem 1rem;
    background: rgba(255, 255, 255, 0.4);
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    text-align: center;
    font-weight: 700;
    color: #1a1a1a;
    font-size: 0.9rem;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);
}

.action-card:hover {
    border-color: #f7bd20;
    transform: translateY(-6px);
    box-shadow: 0 15px 35px rgba(247, 189, 32, 0.1);
    background: white;
}

.action-icon {
    font-size: 2.5rem;
    transition: transform 0.3s ease;
}

.action-card:hover .action-icon {
    transform: scale(1.2) rotate(5deg);
}

/* Activity Items */
.activity-item-new {
    padding: 1.25rem 1.75rem;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.6);
    transition: all 0.3s ease;
}

.activity-item-new:hover {
    background: white;
    transform: translateX(8px);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
}

.activity-content {
    display: flex;
    align-items: center;
    gap: 1.25rem;
}

.activity-info h4 {
    margin: 0 0 0.25rem;
    font-size: 1.05rem;
    font-weight: 700;
    color: #1a1a1a;
}

.activity-info p {
    margin: 0;
    font-size: 0.9rem;
    color: #64748b;
    font-weight: 500;
}

.activity-time {
    font-size: 0.8rem;
    color: #94a3b8;
    font-weight: 600;
    white-space: nowrap;
}

.action-card span {
    letter-spacing: -0.2px;
}

/* Loan Application Modal */
.loan-modal {
    background: #fff;
    border-radius: 20px;
    padding: 2.5rem;
    max-width: 550px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    animation: slideUp 0.3s ease;
}

.modal-close {
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    background: #f5f7fa;
    color: #666;
    font-size: 1.75rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    line-height: 1;
}

.modal-close:hover {
    background: #e8ecf0;
    color: #1a1a1a;
}

.loan-modal h2 {
    font-size: 1.75rem;
    margin: 0 0 0.5rem;
    color: #1a1a1a;
    font-weight: 700;
}

.modal-subtitle {
    color: #666;
    margin: 0 0 2rem;
    font-size: 1rem;
}

.form-group {
    margin-bottom: 1.5rem;
}

.form-group label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 600;
    color: #1a1a1a;
    font-size: 0.95rem;
}

.form-group input,
.form-group select,
.form-group textarea {
    width: 100%;
    padding: 0.9rem 1.1rem;
    border: 2px solid #f5f7fa;
    border-radius: 10px;
    font-size: 1rem;
    font-family: inherit;
    transition: all 0.2s ease;
    background: #fff;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
    outline: none;
    border-color: rgba(247, 189, 32, 0.5);
    box-shadow: 0 0 0 3px rgba(247, 189, 32, 0.1);
}

.form-group textarea {
    resize: vertical;
    min-height: 80px;
}

/* Payment Summary */
.payment-summary {
    background: linear-gradient(135deg, rgba(247, 189, 32, 0.1), rgba(247, 189, 32, 0.05));
    border-radius: 12px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.summary-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.summary-item span {
    color: #666;
    font-size: 0.95rem;
}

.summary-item strong {
    color: #1a1a1a;
    font-size: 1.25rem;
    font-weight: 700;
}

.form-actions {
    display: flex;
    gap: 1rem;
    margin-top: 2rem;
}

.form-actions button {
    flex: 1 1;
}

/* Responsive Design */
@media (max-width: 768px) {
    .welcome-section {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }

    .welcome-section h1 {
        font-size: 1.75rem;
    }

    .stats-cards {
        grid-template-columns: 1fr;
        gap: 1rem;
    }

    .loans-grid {
        grid-template-columns: 1fr;
    }

    .quick-actions-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 0.75rem;
    }

    .loan-info-grid {
        grid-template-columns: 1fr;
    }

    .form-actions {
        flex-direction: column;
    }

    .loan-modal {
        padding: 1.5rem;
        width: 100%;
        margin: 0;
        border-radius: 20px 20px 0 0;
        position: fixed;
        bottom: 0;
        max-height: 85vh;
    }

    .content-section {
        padding: 1.25rem;
        border-radius: 16px;
    }

    .stat-card-new {
        padding: 1.25rem;
    }

    .stat-value-large {
        font-size: 1.8rem;
    }
}

@media (max-width: 480px) {
    .quick-actions-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .action-card {
        padding: 1rem 0.5rem;
    }

    .action-icon {
        font-size: 1.75rem;
    }

    .action-card span {
        font-size: 0.8rem;
    }
}

/* Disbursement History */
.history-count {
    background: rgba(59, 130, 246, 0.15);
    color: #3b82f6;
    padding: 0.4rem 1rem;
    border-radius: 20px;
    font-size: 0.9rem;
    font-weight: 600;
}

.disbursement-table {
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #f5f7fa;
}

.table-header {
    display: grid;
    grid-template-columns: 1fr 1.5fr 1.5fr 1.5fr 1fr;
    background: linear-gradient(135deg, rgba(247, 189, 32, 0.1), rgba(247, 189, 32, 0.05));
    font-weight: 700;
    padding: 1.25rem 1.5rem;
    font-size: 0.9rem;
    color: #1a1a1a;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.table-col {
    display: flex;
    align-items: center;
}

.table-row {
    display: grid;
    grid-template-columns: 1fr 1.5fr 1.5fr 1.5fr 1fr;
    padding: 1.25rem 1.5rem;
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.2s ease;
}

.table-row:last-child {
    border-bottom: none;
}

.table-row:hover {
    background: #fafbfc;
}

.table-cell {
    display: flex;
    align-items: center;
}

.cell-label {
    display: none;
    font-size: 0.75rem;
    color: #999;
    font-weight: 600;
    margin-bottom: 0.25rem;
}

.cell-value {
    font-size: 0.95rem;
    color: #1a1a1a;
}

.account-num {
    font-family: 'Courier New', monospace;
    font-weight: 600;
    color: #666;
}

.amount-disbursed {
    font-weight: 700;
    color: #16a34a;
    font-size: 1.05rem;
}

.status-pill {
    padding: 0.35rem 0.85rem;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: inline-block;
}

.status-pill.completed {
    background: rgba(34, 197, 94, 0.15);
    color: #16a34a;
}

.status-pill.closed {
    background: rgba(100, 116, 139, 0.15);
    color: #64748b;
}

.status-pill.pending {
    background: rgba(247, 189, 32, 0.15);
    color: #f59e0b;
}

.status-pill.in-progress {
    background: rgba(59, 130, 246, 0.15);
    color: #2563eb;
}

.status-pill.rejected {
    background: rgba(239, 68, 68, 0.15);
    color: #dc2626;
}

.total-disbursed {
    margin-top: 1.5rem;
    padding: 1.5rem;
    background: linear-gradient(135deg, rgba(247, 189, 32, 0.15), rgba(247, 189, 32, 0.08));
    border-radius: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.total-disbursed span {
    font-size: 1.05rem;
    font-weight: 600;
    color: #666;
}

.total-disbursed strong {
    font-size: 1.75rem;
    font-weight: 800;
    color: #1a1a1a;
}

@media (max-width: 920px) {
    .table-header {
        display: none;
    }

    .table-row {
        grid-template-columns: 1fr;
        gap: 0.75rem;
        padding: 1.5rem;
    }

    .table-cell {
        flex-direction: column;
        align-items: flex-start;
    }

    .cell-label {
        display: block;
    }

    .total-disbursed {
        flex-direction: column;
        gap: 0.75rem;
        align-items: flex-start;
    }
}

/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    -webkit-backdrop-filter: blur(4px);
            backdrop-filter: blur(4px);
}

.modal-content {
    background: white;
    border-radius: 16px;
    max-width: 600px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    position: relative;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    border-bottom: 1px solid #e5e7eb;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
    border-radius: 16px 16px 0 0;
}

.modal-header h2 {
    margin: 0;
    font-size: 1.5rem;
    color: #1a1a1a;
    font-weight: 700;
}

.close-btn {
    position: absolute;
    top: 1rem;
    right: 1rem;
    background: #f1f5f9;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    font-size: 1.5rem;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
    transition: all 0.2s ease;
}

.close-btn:hover {
    background: #e2e8f0;
    color: #1a1a1a;
    transform: rotate(90deg);
}`, "",{"version":3,"sources":["webpack://./src/pages/DashboardPage.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,SAAS;IACT,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,2DAA2D;IAC3D,gBAAW;IAAX,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,kFAAkF;IAClF,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA,+BAA+B;AAC/B;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA,eAAe;AACf;IACI,aAAa;IACb,4DAA4D;IAC5D,gBAAW;IAAX,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,kCAA0B;YAA1B,0BAA0B;IAC1B,0CAA0C;IAC1C,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,sFAAsF;IACtF,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAY;IAAZ,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oDAAoD;IACpD,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kDAAkD;IAClD,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,4DAA4D;IAC5D,iBAAY;IAAZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,oCAAoC;IACpC,mCAA2B;YAA3B,2BAA2B;IAC3B,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,iDAAiD;IACjD,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,+CAA+C;IAC/C,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;AACtC;;AAEA,mBAAmB;AACnB;IACI,wBAAwB;IACxB,oCAAoC;IACpC,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mCAA2B;YAA3B,2BAA2B;IAC3B,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;;;IAGI,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;;IAGI,aAAa;IACb,qCAAqC;IACrC,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,sFAAsF;IACtF,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAO;AACX;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,qCAAqC;QACrC,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,WAAW;QACX,SAAS;QACT,4BAA4B;QAC5B,eAAe;QACf,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,yBAAyB;AACzB;IACI,oCAAoC;IACpC,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,sFAAsF;IACtF,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,uBAAuB;IACvB,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,uFAAuF;IACvF,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,uBAAuB;IAC3B;AACJ;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,gCAAgC;IAChC,wBAAgB;IAAhB,gBAAgB;IAChB,MAAM;IACN,iBAAiB;IACjB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,wBAAwB;AAC5B","sourcesContent":[".dashboard-page-new {\n    padding: 0;\n}\n\n/* Welcome Section */\n.welcome-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 2rem;\n    flex-wrap: wrap;\n    gap: 1.5rem;\n}\n\n.welcome-section h1 {\n    font-size: 2rem;\n    margin: 0;\n    color: #1a1a1a;\n    font-weight: 700;\n}\n\n.welcome-subtitle {\n    color: #666;\n    margin: 0.5rem 0 0;\n    font-size: 1.05rem;\n}\n\n.btn-primary {\n    background: linear-gradient(135deg, #f7bd20, #f5a623);\n    color: #1a1a1a;\n    border: none;\n    padding: 0.9rem 1.75rem;\n    border-radius: 12px;\n    font-weight: 700;\n    font-size: 1rem;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    transition: all 0.2s ease;\n    box-shadow: 0 4px 15px rgba(247, 189, 32, 0.3);\n}\n\n.btn-primary:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px rgba(247, 189, 32, 0.4);\n}\n\n.btn-secondary {\n    background: #f5f7fa;\n    color: #1a1a1a;\n    border: 1px solid #ddd;\n    padding: 0.9rem 1.75rem;\n    border-radius: 12px;\n    font-weight: 600;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.btn-secondary:hover {\n    background: #e8ecf0;\n}\n\n/* Clean Stats Cards */\n.stats-cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 1.5rem;\n    margin-bottom: 2rem;\n}\n\n.stat-card-new {\n    background: #ffffff;\n    padding: 1.5rem;\n    border-radius: 12px;\n    border: 1px solid #edf2f7;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.stat-card-new:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08);\n}\n\n.stat-card-new.primary-card {\n    border-top: 4px solid #f7bd20;\n}\n\n.stat-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0.75rem;\n}\n\n.stat-icon {\n    font-size: 1.25rem;\n}\n\n.stat-label {\n    font-size: 0.875rem;\n    font-weight: 600;\n    color: #4a5568;\n    text-transform: uppercase;\n    letter-spacing: 0.025em;\n}\n\n.stat-value-large {\n    font-size: 1.875rem;\n    font-weight: 700;\n    color: #1a202c;\n    margin: 0.25rem 0;\n}\n\n.stat-footer {\n    margin-top: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid #f7fafc;\n}\n\n.stat-badge {\n    font-size: 0.75rem;\n    font-weight: 700;\n    padding: 0.25rem 0.75rem;\n    border-radius: 9999px;\n}\n\n.stat-text {\n    font-size: 0.875rem;\n    color: #718096;\n}\n\n.score-bar {\n    height: 6px;\n    background: #edf2f7;\n    border-radius: 3px;\n    overflow: hidden;\n    margin-top: 0.75rem;\n}\n\n.score-fill {\n    height: 100%;\n    background: #f7bd20;\n    border-radius: 3px;\n    transition: width 1s ease-in-out;\n}\n\n/* Dashboard Content Sections */\n.content-section {\n    background: #ffffff;\n    padding: 2rem;\n    border-radius: 12px;\n    border: 1px solid #edf2f7;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n}\n\n.section-header-new {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.5rem;\n}\n\n.section-header-new h2 {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #1a202c;\n    margin: 0;\n}\n\n.loan-count {\n    background: #1a1a1a;\n    color: #f7bd20;\n    padding: 0.5rem 1.25rem;\n    border-radius: 12px;\n    font-size: 0.85rem;\n    font-weight: 700;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n/* Loans Grid */\n.loans-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n    gap: 1.5rem;\n}\n\n.loan-card-new {\n    background: rgba(255, 255, 255, 0.6);\n    backdrop-filter: blur(5px);\n    border: 1px solid rgba(255, 255, 255, 0.5);\n    border-radius: 20px;\n    padding: 1.75rem;\n    transition: all 0.3s ease;\n}\n\n.loan-card-new:hover {\n    border-color: rgba(247, 189, 32, 0.4);\n    transform: translateY(-4px);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n}\n\n.loan-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 1.25rem;\n    gap: 1rem;\n}\n\n.loan-card-header h3 {\n    font-size: 1.25rem;\n    margin: 0 0 0.4rem;\n    color: #1a1a1a;\n    font-weight: 700;\n}\n\n.account-number {\n    font-size: 0.85rem;\n    color: #666;\n    font-weight: 500;\n}\n\n.status-badge {\n    padding: 0.4rem 0.9rem;\n    border-radius: 20px;\n    font-size: 0.75rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    white-space: nowrap;\n}\n\n.status-badge.active {\n    background: rgba(34, 197, 94, 0.15);\n    color: #16a34a;\n}\n\n.loan-amount-display {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    padding: 1.25rem;\n    background: linear-gradient(135deg, rgba(247, 189, 32, 0.1), rgba(247, 189, 32, 0.05));\n    border-radius: 12px;\n    margin-bottom: 1.25rem;\n}\n\n.amount-label {\n    font-size: 0.85rem;\n    color: #666;\n    font-weight: 600;\n}\n\n.amount-value {\n    font-size: 1.75rem;\n    font-weight: 800;\n    color: #1a1a1a;\n}\n\n.loan-info-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1.25rem;\n    margin-bottom: 1.5rem;\n    padding-bottom: 1.5rem;\n    border-bottom: 1px solid #f5f7fa;\n}\n\n.info-item {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.info-label {\n    font-size: 0.85rem;\n    color: #666;\n    font-weight: 500;\n}\n\n.info-value {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: #1a1a1a;\n}\n\n.loan-progress-section {\n    margin-bottom: 1.5rem;\n}\n\n.progress-label {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 0.75rem;\n    font-size: 0.9rem;\n    font-weight: 600;\n    color: #666;\n}\n\n.progress-percent {\n    color: #f7bd20;\n    font-weight: 700;\n}\n\n.progress-bar-new {\n    height: 8px;\n    background: #f5f7fa;\n    border-radius: 10px;\n    overflow: hidden;\n}\n\n.progress-bar-fill {\n    height: 100%;\n    background: linear-gradient(90deg, #f7bd20, #f5a623);\n    border-radius: 10px;\n    transition: width 1s ease;\n}\n\n.btn-pay-emi {\n    width: 100%;\n    padding: 0.9rem;\n    background: linear-gradient(135deg, #1a1a1a, #333);\n    color: #f7bd20;\n    border: none;\n    border-radius: 10px;\n    font-weight: 700;\n    font-size: 0.95rem;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.btn-pay-emi:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);\n}\n\n/* Quick Actions Grid */\n.quick-actions-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n    gap: 1.25rem;\n}\n\n.action-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1rem;\n    padding: 2rem 1rem;\n    background: rgba(255, 255, 255, 0.4);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.8);\n    border-radius: 20px;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n    text-align: center;\n    font-weight: 700;\n    color: #1a1a1a;\n    font-size: 0.9rem;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);\n}\n\n.action-card:hover {\n    border-color: #f7bd20;\n    transform: translateY(-6px);\n    box-shadow: 0 15px 35px rgba(247, 189, 32, 0.1);\n    background: white;\n}\n\n.action-icon {\n    font-size: 2.5rem;\n    transition: transform 0.3s ease;\n}\n\n.action-card:hover .action-icon {\n    transform: scale(1.2) rotate(5deg);\n}\n\n/* Activity Items */\n.activity-item-new {\n    padding: 1.25rem 1.75rem;\n    background: rgba(255, 255, 255, 0.4);\n    border-radius: 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.6);\n    transition: all 0.3s ease;\n}\n\n.activity-item-new:hover {\n    background: white;\n    transform: translateX(8px);\n    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);\n}\n\n.activity-content {\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n}\n\n.activity-info h4 {\n    margin: 0 0 0.25rem;\n    font-size: 1.05rem;\n    font-weight: 700;\n    color: #1a1a1a;\n}\n\n.activity-info p {\n    margin: 0;\n    font-size: 0.9rem;\n    color: #64748b;\n    font-weight: 500;\n}\n\n.activity-time {\n    font-size: 0.8rem;\n    color: #94a3b8;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\n.action-card span {\n    letter-spacing: -0.2px;\n}\n\n/* Loan Application Modal */\n.loan-modal {\n    background: #fff;\n    border-radius: 20px;\n    padding: 2.5rem;\n    max-width: 550px;\n    width: 90%;\n    max-height: 90vh;\n    overflow-y: auto;\n    position: relative;\n    animation: slideUp 0.3s ease;\n}\n\n.modal-close {\n    position: absolute;\n    top: 1.5rem;\n    right: 1.5rem;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    border: none;\n    background: #f5f7fa;\n    color: #666;\n    font-size: 1.75rem;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    line-height: 1;\n}\n\n.modal-close:hover {\n    background: #e8ecf0;\n    color: #1a1a1a;\n}\n\n.loan-modal h2 {\n    font-size: 1.75rem;\n    margin: 0 0 0.5rem;\n    color: #1a1a1a;\n    font-weight: 700;\n}\n\n.modal-subtitle {\n    color: #666;\n    margin: 0 0 2rem;\n    font-size: 1rem;\n}\n\n.form-group {\n    margin-bottom: 1.5rem;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-weight: 600;\n    color: #1a1a1a;\n    font-size: 0.95rem;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n    width: 100%;\n    padding: 0.9rem 1.1rem;\n    border: 2px solid #f5f7fa;\n    border-radius: 10px;\n    font-size: 1rem;\n    font-family: inherit;\n    transition: all 0.2s ease;\n    background: #fff;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n    outline: none;\n    border-color: rgba(247, 189, 32, 0.5);\n    box-shadow: 0 0 0 3px rgba(247, 189, 32, 0.1);\n}\n\n.form-group textarea {\n    resize: vertical;\n    min-height: 80px;\n}\n\n/* Payment Summary */\n.payment-summary {\n    background: linear-gradient(135deg, rgba(247, 189, 32, 0.1), rgba(247, 189, 32, 0.05));\n    border-radius: 12px;\n    padding: 1.5rem;\n    margin-bottom: 1.5rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.summary-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.summary-item span {\n    color: #666;\n    font-size: 0.95rem;\n}\n\n.summary-item strong {\n    color: #1a1a1a;\n    font-size: 1.25rem;\n    font-weight: 700;\n}\n\n.form-actions {\n    display: flex;\n    gap: 1rem;\n    margin-top: 2rem;\n}\n\n.form-actions button {\n    flex: 1;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .welcome-section {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 1rem;\n    }\n\n    .welcome-section h1 {\n        font-size: 1.75rem;\n    }\n\n    .stats-cards {\n        grid-template-columns: 1fr;\n        gap: 1rem;\n    }\n\n    .loans-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .quick-actions-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 0.75rem;\n    }\n\n    .loan-info-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .form-actions {\n        flex-direction: column;\n    }\n\n    .loan-modal {\n        padding: 1.5rem;\n        width: 100%;\n        margin: 0;\n        border-radius: 20px 20px 0 0;\n        position: fixed;\n        bottom: 0;\n        max-height: 85vh;\n    }\n\n    .content-section {\n        padding: 1.25rem;\n        border-radius: 16px;\n    }\n\n    .stat-card-new {\n        padding: 1.25rem;\n    }\n\n    .stat-value-large {\n        font-size: 1.8rem;\n    }\n}\n\n@media (max-width: 480px) {\n    .quick-actions-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .action-card {\n        padding: 1rem 0.5rem;\n    }\n\n    .action-icon {\n        font-size: 1.75rem;\n    }\n\n    .action-card span {\n        font-size: 0.8rem;\n    }\n}\n\n/* Disbursement History */\n.history-count {\n    background: rgba(59, 130, 246, 0.15);\n    color: #3b82f6;\n    padding: 0.4rem 1rem;\n    border-radius: 20px;\n    font-size: 0.9rem;\n    font-weight: 600;\n}\n\n.disbursement-table {\n    border-radius: 12px;\n    overflow: hidden;\n    border: 1px solid #f5f7fa;\n}\n\n.table-header {\n    display: grid;\n    grid-template-columns: 1fr 1.5fr 1.5fr 1.5fr 1fr;\n    background: linear-gradient(135deg, rgba(247, 189, 32, 0.1), rgba(247, 189, 32, 0.05));\n    font-weight: 700;\n    padding: 1.25rem 1.5rem;\n    font-size: 0.9rem;\n    color: #1a1a1a;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.table-col {\n    display: flex;\n    align-items: center;\n}\n\n.table-row {\n    display: grid;\n    grid-template-columns: 1fr 1.5fr 1.5fr 1.5fr 1fr;\n    padding: 1.25rem 1.5rem;\n    border-bottom: 1px solid #f5f7fa;\n    transition: background 0.2s ease;\n}\n\n.table-row:last-child {\n    border-bottom: none;\n}\n\n.table-row:hover {\n    background: #fafbfc;\n}\n\n.table-cell {\n    display: flex;\n    align-items: center;\n}\n\n.cell-label {\n    display: none;\n    font-size: 0.75rem;\n    color: #999;\n    font-weight: 600;\n    margin-bottom: 0.25rem;\n}\n\n.cell-value {\n    font-size: 0.95rem;\n    color: #1a1a1a;\n}\n\n.account-num {\n    font-family: 'Courier New', monospace;\n    font-weight: 600;\n    color: #666;\n}\n\n.amount-disbursed {\n    font-weight: 700;\n    color: #16a34a;\n    font-size: 1.05rem;\n}\n\n.status-pill {\n    padding: 0.35rem 0.85rem;\n    border-radius: 12px;\n    font-size: 0.75rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    display: inline-block;\n}\n\n.status-pill.completed {\n    background: rgba(34, 197, 94, 0.15);\n    color: #16a34a;\n}\n\n.status-pill.closed {\n    background: rgba(100, 116, 139, 0.15);\n    color: #64748b;\n}\n\n.status-pill.pending {\n    background: rgba(247, 189, 32, 0.15);\n    color: #f59e0b;\n}\n\n.status-pill.in-progress {\n    background: rgba(59, 130, 246, 0.15);\n    color: #2563eb;\n}\n\n.status-pill.rejected {\n    background: rgba(239, 68, 68, 0.15);\n    color: #dc2626;\n}\n\n.total-disbursed {\n    margin-top: 1.5rem;\n    padding: 1.5rem;\n    background: linear-gradient(135deg, rgba(247, 189, 32, 0.15), rgba(247, 189, 32, 0.08));\n    border-radius: 12px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.total-disbursed span {\n    font-size: 1.05rem;\n    font-weight: 600;\n    color: #666;\n}\n\n.total-disbursed strong {\n    font-size: 1.75rem;\n    font-weight: 800;\n    color: #1a1a1a;\n}\n\n@media (max-width: 920px) {\n    .table-header {\n        display: none;\n    }\n\n    .table-row {\n        grid-template-columns: 1fr;\n        gap: 0.75rem;\n        padding: 1.5rem;\n    }\n\n    .table-cell {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .cell-label {\n        display: block;\n    }\n\n    .total-disbursed {\n        flex-direction: column;\n        gap: 0.75rem;\n        align-items: flex-start;\n    }\n}\n\n/* Modal Styles */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    backdrop-filter: blur(4px);\n}\n\n.modal-content {\n    background: white;\n    border-radius: 16px;\n    max-width: 600px;\n    width: 90%;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    position: relative;\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1.5rem;\n    border-bottom: 1px solid #e5e7eb;\n    position: sticky;\n    top: 0;\n    background: white;\n    z-index: 10;\n    border-radius: 16px 16px 0 0;\n}\n\n.modal-header h2 {\n    margin: 0;\n    font-size: 1.5rem;\n    color: #1a1a1a;\n    font-weight: 700;\n}\n\n.close-btn {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    background: #f1f5f9;\n    border: none;\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    font-size: 1.5rem;\n    line-height: 1;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #64748b;\n    transition: all 0.2s ease;\n}\n\n.close-btn:hover {\n    background: #e2e8f0;\n    color: #1a1a1a;\n    transform: rotate(90deg);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
